import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Stethoscope,
  Syringe,
  Scissors,
  Microscope,
  HeartPulse,
  ShoppingBag,
  ArrowRight,
} from "lucide-react";

const SERVICES = [
  {
    slug: "consultas",
    icon: Stethoscope,
    title: "Consultas e check-up",
    desc: "Avaliações de rotina e acompanhamento clínico para detetar problemas cedo.",
  },
  {
    slug: "vacinacao",
    icon: Syringe,
    title: "Vacinação",
    desc: "Plano vacinal personalizado para cães, gatos e animais exóticos.",
  },
  {
    slug: "cirurgia",
    icon: Scissors,
    title: "Cirurgia",
    desc: "Cirurgias gerais e de tecidos moles com protocolos seguros de anestesia.",
  },
  {
    slug: "analises",
    icon: Microscope,
    title: "Análises e Diagnóstico",
    desc: "Hemogramas, bioquímicas, ecografia e radiologia digital no local.",
  },
  {
    slug: "urgencias",
    icon: HeartPulse,
    title: "Urgências",
    desc: "Atendimento rápido em situações críticas dentro do horário das clínicas.",
  },
  {
    slug: "petshop",
    icon: ShoppingBag,
    title: "PetShop",
    desc: "Alimentação especializada, suplementos e acessórios recomendados pela equipa.",
  },
];

export const ServicesGrid = () => {
  return (
    <section
      data-testid="services-section"
      className="relative py-20 md:py-28 bg-[#FAF7F2]"
    >
      <div className="container-app">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#88A096] mb-3">
              Os nossos serviços
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight">
              Cuidado completo, do <span className="text-[#1E5F6E]">primeiro</span> ao último dia.
            </h2>
          </div>
          <p className="md:max-w-sm text-base text-[#5A5A5A] leading-relaxed">
            Da prevenção à cirurgia, a nossa equipa acompanha cada fase da vida
            do seu animal com a mesma dedicação.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
                data-testid={`service-card-${s.slug}`}
                className="group relative overflow-hidden rounded-2xl bg-white border border-[#1E5F6E]/8 p-7 hover:border-[#1E5F6E]/25 transition-all hover:-translate-y-1 hover:shadow-soft"
              >
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#1E5F6E]/8 text-[#1E5F6E] mb-5 transition-colors group-hover:bg-[#1E5F6E] group-hover:text-white">
                  <Icon className="h-6 w-6" strokeWidth={2.1} />
                </span>
                <h3 className="font-display text-xl font-bold text-[#1A1A1A]">
                  {s.title}
                </h3>
                <p className="mt-2 text-[15px] text-[#5A5A5A] leading-relaxed line-clamp-2">
                  {s.desc}
                </p>
                <Link
                  to={`/servicos#${s.slug}`}
                  className="mt-5 inline-flex items-center gap-1 text-sm font-bold text-[#1E5F6E] hover:gap-2 transition-all"
                >
                  Saber mais
                  <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/servicos"
            data-testid="services-view-all"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1E5F6E] px-7 py-4 text-base font-bold text-white shadow-[0_10px_25px_-10px_rgba(30,95,110,0.6)] hover:bg-[#174E5B] hover:-translate-y-0.5 transition-all"
          >
            Ver todos os serviços
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
